export enum TypeCode {
  Baseline = 'Baseline',
  WIS = 'WIS'
}
